export enum RuleType {
  USER = 'user',
  CUSTOMER = 'customer',
  PERCENTAGE_USERS = 'percentage_users',
  PERCENTAGE_CUSTOMERS = 'percentage_customers',
  ATTRIBUTE = 'attribute',
  DEFAULT = 'default',
}

export interface FlagRule {
  type: RuleType;
  enabled: boolean;
  priority: number;
  targetId?: string;
  percentage?: number;
  attributes?: Record<string, unknown>;
  variant?: string;
}

export interface FlagDefinition {
  key: string;
  description: string;
  enabled: boolean;
  rules: FlagRule[];
  variants?: Record<string, unknown>;
  metadata?: Record<string, unknown>;
}

export interface FlagListResponse {
  flags: FlagDefinition[];
  total: number;
  version: string;
  lastUpdated: string;
}

export interface FlagUpdateResponse {
  success: boolean;
  flagKey: string;
  version: string;
  propagationStatus: string;
  estimatedPropagationTime: number;
}

export interface ValidationError {
  field: string;
  message: string;
  code: string;
}

export interface ValidationResponse {
  valid: boolean;
  errors: ValidationError[];
}

export interface ConfigVersionResponse {
  version: string;
  lastUpdated: string;
  flagCount: number;
}
